import MobileLayourReducter, { mobileLayouSlice } from "./slice";

export const { resetState, setShowTopNav, clearTopNavNameTitle, setTopNavNameTitle } = mobileLayouSlice.actions;
export { MobileLayourReducter };
